export default __webpack_public_path__ + "static/Jesse-high-5-123ae078771b152d6df8e7947ce7e151.jpg";